import { useQuery } from '@tanstack/react-query';
import { walletService } from '@/services/walletService';

export function useWalletBalance() {
  return useQuery({
    queryKey: ['wallet', 'balance'],
    queryFn: async () => {
      const result = await walletService.getBalance();
      if (!result.success) throw new Error(result.error);
      return result.balance;
    },
    staleTime: 2 * 60 * 1000,
  });
}
